export default __webpack_public_path__ + "static/ideal-logo-d042cffb3f8938e39dc5dd3c8889faa2.png";